import { ODSCardBasic, ODSButton, ODSText } from "@telekom-ods/react-ui-kit";
import classes from "./SuccessfulVerification.module.scss";
import { APP_CONSTANTS } from "../../../core/config/appConstants";

const DefaultCard = () => (
	<ODSCardBasic
		actionSlot={
			<div className={classes.cardButtonContainer}>
				<ODSButton
					label="Zum Kundencenter"
					onClick={() =>
						(window.location.href =
							APP_CONSTANTS.LINK.KUNDENCENTER)
					}
					size="small"
					tabIndex="1"
				/>
			</div>
		}
		contentSlot={
			<>
				<ODSText as="h2" className={classes.cardHeader}>
					Verträge online verwalten
				</ODSText>
				<ODSText as="pa" className="body m-0">
					Im Kundencenter können Sie einfach und
					schnell Ihre Personendaten und Verträge
					einsehen und ändern.
				</ODSText>
			</>
		}
		size="large"
	/>
);

export default DefaultCard;
